import { CHECK_LOGIN, LOGIN_USER_SUCCESSFUL, API_ERROR, LOGOUT_USER, LOGOUT_USER_SUCCESS } from './actionTypes';

const initialState = {
    loginError: "aaa", message: null, loading: false, user:""
}

const login = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_LOGIN:
            return {
                ...state,
                loading: true
            }
        case LOGIN_USER_SUCCESSFUL:
            return {
                ...state,
                loading: false,
                user: {...action.payload,
                    password:""}
            }

        case LOGOUT_USER:
            return { ...state};
            

        case LOGOUT_USER_SUCCESS:
            return { ...state, user:"" };
            
            
        case API_ERROR:
            return{
                ...state,
                loading: false,
                loginError: action.payload
            }
           

        default:
            return state ;
    }
}

export default login;